import { render, staticRenderFns } from "./PatentExtraFeeForm.vue?vue&type=template&id=1563c960&scoped=true&"
import script from "./PatentExtraFeeForm.vue?vue&type=script&lang=ts&"
export * from "./PatentExtraFeeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1563c960",
  null
  
)

export default component.exports